var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('widget', [_c('widget-header', {
    staticClass: "background-gradient-green-blue text-white tiny-forms"
  }, [_c('i', {
    staticClass: "zmdi zmdi-file-plus pr-2"
  }), _vm._v(" Delete Alf Listing "), _c('h4', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('close-x', {
    staticClass: "text-white",
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  })], 1)]), _c('widget-body', [_c('form', {
    ref: "form",
    staticClass: "x-form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.update.apply(null, arguments);
      }
    }
  }, [_vm.alfException.user ? _c('YInput', {
    attrs: {
      "readonly": true,
      "label": "User"
    },
    model: {
      value: _vm.alfException.user.label,
      callback: function ($$v) {
        _vm.$set(_vm.alfException.user, "label", $$v);
      },
      expression: "alfException.user.label"
    }
  }) : _vm._e(), _vm.alfException.subdomain ? _c('YInput', {
    attrs: {
      "readonly": true,
      "label": "Subdomain"
    },
    model: {
      value: _vm.alfException.subdomain,
      callback: function ($$v) {
        _vm.$set(_vm.alfException, "subdomain", $$v);
      },
      expression: "alfException.subdomain"
    }
  }) : _vm._e()], 1)]), _c('widget-footer', {
    staticClass: "px-4 py-2 bg-gray-100 text-right"
  }, [_c('y-button', {
    staticClass: "btn btn-red",
    attrs: {
      "is-loading": _vm.isSubmitting
    },
    on: {
      "click": _vm.remove,
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.remove.apply(null, arguments);
      }
    }
  }, [_vm._v("Delete")])], 1), _vm.validationErrors ? _c('ValidationErrors', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }